<template>
  <div class="banner"
       @mousedown="onMouseDown"
       @mouseup="onMouseUp"
       @mouseleave="onMouseLeave">
    <div class="banner-inner" :style="{ transform: `translateX(-${currentIndex * 100}%)` }">
      <div
        class="banner-item"
        v-for="(img, idx) in images"
        :key="idx"
      >
        <img :src="img.image" alt="" draggable="false">
        <!-- <div class="banner-btn">
          <button class="explore-btn" @click="$router.push(img.link)">
            探索更多
            <span class="arrow-circle">
              <svg class="arrow-icon" viewBox="0 0 16 16" fill="none">
                <path d="M0 8h14m-4-4 4 4-4 4" stroke="#fff" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </span>
          </button>
        </div> -->
        <div class="banner-title">
          <span>{{ img.title }}</span>
        </div>
      </div>
    </div>

    <!-- 进度条指示器 -->
    <div class="progress-bar" @click="onProgressClick">
      <div class="progress-fill" :style="{ width: progressWidth }"></div>
    </div>
  </div>
</template>

<script>
import apiServe from "@/services/index.js";

export default {
  name: 'BannerView',
  data() {
    return {
      currentIndex: 0,
      timer: null,
      lang: 'CN',
      images: [
       
      ],
      dragStartX: 0,
      dragging: false
    }
  },
  mounted() {
    this.getIndexData()

    this.startAutoPlay()
  },
  beforeDestroy() {
    this.stopAutoPlay()
  },
  created() {
    const saved = localStorage.getItem('lang')
    if (saved) this.lang = saved
  },
  methods: {
    getIndexData() {
      const data = {
        lang: this.lang,
      };
      apiServe.getIndexData(data).then((res) => {
          this.images = res.data.banner;
      });
    },

    startAutoPlay() {
      this.timer = setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.images.length
      }, 3000)
    },
    stopAutoPlay() {
      clearInterval(this.timer)
      this.timer = null
    },
    onProgressClick(e) {
      const rect = e.currentTarget.getBoundingClientRect()
      const percent = (e.clientX - rect.left) / rect.width
      const nextIndex = Math.floor(percent * this.images.length)
      this.currentIndex = Math.min(nextIndex, this.images.length - 1)
    },
    onMouseDown(e) {
      this.dragStartX = e.clientX
      this.dragging = true
      this.stopAutoPlay()
    },
    onMouseUp(e) {
      if (!this.dragging) return
      this.dragging = false
      const deltaX = e.clientX - this.dragStartX
      if (Math.abs(deltaX) > 30) {
        if (deltaX > 0) {
          this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length
        } else {
          this.currentIndex = (this.currentIndex + 1) % this.images.length
        }
      }
      this.startAutoPlay()
    },
    onMouseLeave() {
      if (this.dragging) {
        this.dragging = false
        this.startAutoPlay()
      }
    }
  },
  computed: {
    progressWidth() {
      return `${((this.currentIndex + 1) / this.images.length) * 100}%`
    }
  }
}
</script>

<style lang="scss" scoped>
.banner {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

@media (max-width: 768px) {
  .banner {
    height: calc(100vh - 75px);
  }
}
.banner-inner {
  display: flex;
  height: 100%;
  transition: transform 0.5s ease;
}
.banner-item {
  flex: 0 0 100%;
  height: 100%;
  user-select: none;
  position: relative;

}
.banner-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 探索更多按钮 */
.banner-btn {
  position: absolute;
  top: 87%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
}

@media (max-width: 768px) {
  .banner-btn {
    top: 80%;
  }
}
.explore-btn {
  display: inline-flex;
  gap: 3rem;
  align-items: center;
  padding: 12px 24px;
  background: #fff;
  border: none;
  border-radius: 24px;
  font-size: 16px;
  color: #333;
  cursor: pointer;
  transition: background .3s;
}
.explore-btn:hover {
  background: #f0f0f0;
}

.arrow-circle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background: #1890ff;
  border-radius: 50%;
  margin-left: 8px;
}
.arrow-icon {
  width: 16px;
  height: 16px;
}
/* banner-title */
.banner-title {
  position: absolute;
  top: 85%;
  right: 0%;
  transform: translate(-50%, -50%);
}

@media (max-width: 768px) {
  .banner-title {
    top: 80%;
    right: 5%;
  }
}
.banner-title span {
  font-size: 18px;
  color: #fff;
}
/* 进度条指示器 */
.progress-bar {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  width: 800px;
  height: 4px;
//   background: rgba(255,255,255,.3);
background: #fff;
  overflow: hidden;
  cursor: pointer;
}

@media (max-width: 768px) {
  .progress-bar {
    width: 90%;
    max-width: 400px;
    bottom: 20px;
  }
}
.progress-fill {
  height: 100%;
  background: #1890ff;
  border-radius: 2px;
  transition: width .5s ease;
}
</style>